// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/hydroplaning.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/hydroplaning/hydroplaning.js';

mount([g0]);
